"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { d: "M4.7071 12.6929c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3905-.3905 1.0237 0 1.4142l4.8295 4.8295c.3913.3913 1.0259.3905 1.4161-.0018L20.709 7.7052c.3895-.3915.3878-1.0247-.0038-1.4142-.3915-.3895-1.0247-.3878-1.4142.0038L8.8277 16.8135 4.707 12.6929Z" })), 'CheckIcon');
